// extracted by mini-css-extract-plugin
export default {"border":"styles_border__Idt-x","border_previous":"styles_border_previous__mUFpF","border_page":"styles_border_page__Eg6PT","border_next":"styles_border_next__WumZK"};